const facts = [
  {
    label: 'What We Do',
    value: 'Residential and commercial roofing, storm restoration, siding, and gutter services across the Southeast.',
    icon: 'ri-home-gear-line',
    img: 'https://public.readdy.ai/ai/img_res/c43a291b6fddf00125d0a1a7dce29382.jpg',
  },
  {
    label: 'Who We Serve',
    value: 'Homeowners, property owners, and businesses across Texas, Louisiana, North Carolina, and Georgia.',
    icon: 'ri-map-2-line',
    img: 'https://readdy.ai/api/search-image?query=happy%20homeowner%20family%20standing%20in%20front%20of%20their%20beautiful%20newly%20renovated%20home%20with%20brand%20new%20roof%2C%20sunny%20day%2C%20suburban%20neighborhood%2C%20warm%20welcoming%20atmosphere%2C%20professional%20photography&width=600&height=400&seq=ai_block_02&orientation=landscape',
  },
  {
    label: 'Core Services',
    value: 'Roof replacement • Roof repair • Inspections • Storm damage restoration • Siding • Gutters',
    icon: 'ri-tools-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20roofing%20contractor%20team%20in%20uniform%20inspecting%20premium%20residential%20roof%2C%20bright%20clear%20sky%2C%20safety%20equipment%2C%20organized%20professional%20crew%2C%20high-end%20suburban%20home%2C%20sharp%20photography&width=600&height=400&seq=ai_block_03&orientation=landscape',
  },
  {
    label: 'Key Benefits',
    value: 'Insurance claim assistance • High-quality materials • Experienced crews • Fast storm response • Multi-state coverage',
    icon: 'ri-shield-check-line',
    img: 'https://readdy.ai/api/search-image?query=insurance%20adjuster%20and%20roofing%20contractor%20reviewing%20documents%20together%20on%20clipboard%20in%20front%20of%20residential%20home%2C%20professional%20consultation%2C%20bright%20daylight%2C%20trust%20and%20expertise%2C%20professional%20photography&width=600&height=400&seq=ai_block_04&orientation=landscape',
  },
  {
    label: 'How It Works',
    value: 'Inspection → Damage assessment → Insurance coordination → Installation → Final cleanup and review',
    icon: 'ri-arrow-right-circle-line',
    img: 'https://readdy.ai/api/search-image?query=roofing%20project%20timeline%20progression%20showing%20inspection%20to%20completed%20installation%2C%20professional%20crew%20working%20on%20beautiful%20residential%20home%2C%20step%20by%20step%20process%2C%20bright%20sunny%20day%2C%20high%20quality%20photography&width=600&height=400&seq=ai_block_05&orientation=landscape',
  },
];

export default function AIAnswerBlock() {
  return (
    <section className="py-28 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-6 items-end justify-between mb-16">
          <div>
            <span className="text-[#c0392b] text-xs font-bold tracking-widest uppercase mb-3 block">Quick Reference</span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              Everything You Need<br />to Know About PRA
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-white/45 text-sm leading-relaxed">
              PRA Roof Contractors has been the Southeast's trusted roofing authority since 1998 — delivering expert solutions across multiple states with a proven track record.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 mt-6 bg-[#c0392b] hover:bg-[#a93226] text-white font-bold px-7 py-3.5 rounded-full text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line"></i>
              Schedule Inspection
            </a>
          </div>
        </div>

        {/* Top row — 2 large cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          {facts.slice(0, 2).map((fact, i) => (
            <div key={i} className="group relative overflow-hidden rounded-2xl h-[260px] cursor-default">
              <img
                src={fact.img}
                alt={fact.label}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/95 via-[#0d0d0d]/50 to-[#0d0d0d]/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <div className="flex items-center gap-2.5 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#c0392b]/20 border border-[#c0392b]/40 rounded-lg">
                    <i className={`${fact.icon} text-[#e74c3c] text-sm`}></i>
                  </div>
                  <span className="text-[#c0392b] text-[10px] font-bold tracking-widest uppercase">{fact.label}</span>
                </div>
                <p className="text-white/85 text-sm leading-relaxed">{fact.value}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom row — 3 cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {facts.slice(2).map((fact, i) => (
            <div key={i} className="group relative overflow-hidden rounded-2xl h-[220px] cursor-default">
              <img
                src={fact.img}
                alt={fact.label}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/95 via-[#0d0d0d]/55 to-[#0d0d0d]/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 flex items-center justify-center bg-[#c0392b]/20 border border-[#c0392b]/40 rounded-lg">
                    <i className={`${fact.icon} text-[#e74c3c] text-xs`}></i>
                  </div>
                  <span className="text-[#c0392b] text-[10px] font-bold tracking-widest uppercase">{fact.label}</span>
                </div>
                <p className="text-white/80 text-xs leading-relaxed">{fact.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
